import { useEffect, useState } from "react";
import { Box, Input as ThemeUiInput } from "theme-ui";
import camelCase from "lodash/camelCase";
import BadWordsFilter from "bad-words";

const badWordsFilter = new BadWordsFilter();
const newBadWords = [
  "Ostie",
  "Esti",
  "Calisse",
  "Tabarnak",
  "Sacrament",
  "Ciboire",
  "Saloppe",
  "Pute",
  "Chienne",
  "Trou d'cul",
  "Trou d cul",
  "Calvaire",
  "Batard",
  "Bite",
  "Plotte",
  "Pétasse",
  "Petasse",
  "Fif",
  "Criss",
  "Colon",
  "Guidoune",
  "Decriss",
];
badWordsFilter.addWords(...newBadWords);
badWordsFilter.removeWords("cox");

const withButtonStyle = ({ isRound }) => ({
  display: "flex",
  flexDirection: "row",

  button: {
    height: "auto",

    ...(isRound
      ? {
          borderTopRightRadius: "10000px",
          borderBottomRightRadius: "10000px",
        }
      : {}),
  },
});

const iconAfterStyles = {
  position: "absolute",
  right: "10px",
  top: "55%",
  transform: "translate(-50%, -50%)",
};

export default function Input({
  variant = "regular", // regular | material | round
  size = "medium", // medium | large
  withButton,
  value: initialValue,
  onChangeTimeout = 200,
  onChange = () => {},
  isDisabled,
  as = "input",
  type = "text", // button | checkbox | color | date | datetime-local | email | file | hidden | image | month | number | password | radio | range | reset | search | submit | tel | text | time | url | week
  valueTransform = (str) => str,
  isInvalid: isInvalidOverride = false,
  iconAfter,
  ...props
}) {
  const [value, setValue] = useState(initialValue || "");

  const isProfane = badWordsFilter.isProfane(value);
  const isInvalid = isInvalidOverride || isProfane;

  const handleChange = ({ target }) => {
    setValue(valueTransform(target.value));
  };

  const variantName = camelCase(
    [
      "input",
      variant,
      size,
      withButton && "withButton",
      isInvalid && "isInvalid",
    ]
      .filter(Boolean)
      .join("-")
  );

  useEffect(() => {
    if (isDisabled) {
      setValue("");
    }
  }, [isDisabled]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (value !== initialValue && !isProfane) {
        onChange(value === "" ? null : value);
      }
    }, onChangeTimeout);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, initialValue, onChangeTimeout]);

  if (withButton) {
    return (
      <Box sx={withButtonStyle({ isRound: variant === "round" })}>
        <ThemeUiInput
          as={as}
          type={type}
          variant={variantName}
          value={value}
          onChange={handleChange}
          disabled={isDisabled}
          {...props}
        />
        {withButton}
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative" }}>
      <ThemeUiInput
        as={as}
        type={type}
        variant={variantName}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        {...props}
      />
      {iconAfter && <Box sx={iconAfterStyles}>{iconAfter}</Box>}
    </Box>
  );
}
